// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.booking-page {
  min-height: 100vh;
  background: var(--brand-bg, #f4f5f6);
  color: var(--brand-text, #1a1a2e);
}

.booking-page.embed-mode .booking-header,
.booking-page.embed-mode .booking-footer {
  display: none;
}

.booking-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: #fff;
  border-bottom: 1px solid #e8e8ef;
}

.booking-header img {
  max-height: 48px;
}

.booking-main {
  max-width: 1100px;
  margin: 0 auto;
  padding: 24px 16px 48px;
}

.booking-hero {
  text-align: center;
  margin-bottom: 32px;
}

.booking-hero h1 {
  font-size: 2rem;
  margin-bottom: 8px;
}

.booking-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 32px;
}

.booking-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.booking-card.selected {
  border-color: var(--brand-primary, #0877bc);
  box-shadow: 0 4px 20px rgba(8, 119, 188, 0.15);
}

.booking-card h3 {
  margin: 0 0 8px;
}

.booking-price {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--brand-primary, #0877bc);
}

.booking-section {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
}

.booking-slots {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 8px;
}

.booking-slot {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fafafa;
  cursor: pointer;
  text-align: center;
  font-size: 0.9rem;
}

.booking-slot.selected {
  background: var(--brand-primary, #0877bc);
  color: #fff;
  border-color: var(--brand-primary, #0877bc);
}

.booking-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
}

@media (max-width: 600px) {
  .booking-form-row {
    grid-template-columns: 1fr;
  }
}

.challenge-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.challenge-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 14px;
  border: 1px solid #e8e8ef;
  border-radius: 10px;
  background: #fafbff;
}

.booking-footer {
  text-align: center;
  padding: 16px;
  color: #888;
  font-size: 0.85rem;
}

.booking-confirm-box {
  max-width: 560px;
  margin: 48px auto;
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  text-align: center;
}

.access-code {
  font-size: 2rem;
  letter-spacing: 4px;
  font-weight: 700;
  color: var(--brand-primary, #0877bc);
  margin: 16px 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/booking.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;AAChB","sourcesContent":[".booking-page {\n  min-height: 100vh;\n  background: var(--brand-bg, #f4f5f6);\n  color: var(--brand-text, #1a1a2e);\n}\n\n.booking-page.embed-mode .booking-header,\n.booking-page.embed-mode .booking-footer {\n  display: none;\n}\n\n.booking-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  background: #fff;\n  border-bottom: 1px solid #e8e8ef;\n}\n\n.booking-header img {\n  max-height: 48px;\n}\n\n.booking-main {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 24px 16px 48px;\n}\n\n.booking-hero {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.booking-hero h1 {\n  font-size: 2rem;\n  margin-bottom: 8px;\n}\n\n.booking-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n  margin-bottom: 32px;\n}\n\n.booking-card {\n  background: #fff;\n  border-radius: 12px;\n  padding: 20px;\n  border: 2px solid transparent;\n  cursor: pointer;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.booking-card.selected {\n  border-color: var(--brand-primary, #0877bc);\n  box-shadow: 0 4px 20px rgba(8, 119, 188, 0.15);\n}\n\n.booking-card h3 {\n  margin: 0 0 8px;\n}\n\n.booking-price {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: var(--brand-primary, #0877bc);\n}\n\n.booking-section {\n  background: #fff;\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 24px;\n}\n\n.booking-slots {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 8px;\n}\n\n.booking-slot {\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background: #fafafa;\n  cursor: pointer;\n  text-align: center;\n  font-size: 0.9rem;\n}\n\n.booking-slot.selected {\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n  border-color: var(--brand-primary, #0877bc);\n}\n\n.booking-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n@media (max-width: 600px) {\n  .booking-form-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.challenge-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.challenge-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 14px;\n  border: 1px solid #e8e8ef;\n  border-radius: 10px;\n  background: #fafbff;\n}\n\n.booking-footer {\n  text-align: center;\n  padding: 16px;\n  color: #888;\n  font-size: 0.85rem;\n}\n\n.booking-confirm-box {\n  max-width: 560px;\n  margin: 48px auto;\n  background: #fff;\n  border-radius: 12px;\n  padding: 32px;\n  text-align: center;\n}\n\n.access-code {\n  font-size: 2rem;\n  letter-spacing: 4px;\n  font-weight: 700;\n  color: var(--brand-primary, #0877bc);\n  margin: 16px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
